import dayjs from "dayjs";

export const formatFilterDate = (date) => {
  return  dayjs(date).format('YYYY-MM-DD') + 'T00:00:00+00:00';
}

export const formatStartDate = (date) => {
  return dayjs(formatFilterDate(date)).subtract(1, 'second').unix();
}

export const formatEndDate = (date) => {
  return dayjs(formatFilterDate(date)).add(1, 'day').subtract(1, 'second').unix();
}



// WEBPACK FOOTER //
// ./src/utils/date.js